import React, { useState, useEffect, Suspense, lazy } from 'react';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { Route, Switch } from 'react-router-dom';
import { AuthProvider } from '../../context/auth';
import classnames from 'classnames';
import { useMediaQuery } from 'react-responsive';
import ReactNotification from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import { isMobile } from 'react-device-detect';
import isEmpty from '../../validation/is-empty';

import './Admin.scss';
import AuthRoute from './util/AuthRoute';
import PrivateRoute from './util/PrivateRoute';
import Navbar from './navbar/Navbar';

const Login = lazy(() => import('./login/Login'));
const Home = lazy(() => import('./home/Home'));
const Onboardings = lazy(() => import('./onboardings/Onboardings'));
const CronJobs = lazy(() => import('./cron-jobs/CronJobs'));
const UpdateCsd = lazy(() => import('./update-csd/UpdateCsd'));
const CancelInvoice = lazy(() => import('./cancel-invoice/CancelInvoice'));
// SPDM Components
const BranchOffices = lazy(() => import('./caesar-vision/branch-offices'));
// const SearchInvoice = lazy(() => import('./caesar-vision/search-invoice/SearchInvoice'));
// Handlers
const NotFound = lazy(() => import('../not-found/NotFound'));

function Admin() {
  const [showNavbar, setShowNavbar] = useState(true);
  const withNavbar = showNavbar && !isEmpty(localStorage.getItem('jwtToken'));
  const sideNavFixed = useMediaQuery({
    query: '(min-width: 1280px)',
  });

  useEffect(() => {
    return () => {
      document.getElementById('manifest-admin').remove();
    };
  }, []);

  return (
    <div
      className={classnames('Admin', {
        'with-navbar': withNavbar,
        'sidenav-fixed': withNavbar && sideNavFixed,
      })}
    >
      <HelmetProvider>
        <Helmet>
          <link
            id="manifest-admin"
            rel="manifest"
            href="/manifest-admin.json"
          />
          {isMobile && <body class="mobile" />}
        </Helmet>

        <ReactNotification />
        <main className="content-wrap">
          <AuthProvider>
            <Navbar showNavbar={showNavbar} sideNavFixed={sideNavFixed} />
            <Suspense fallback={null}>
              <Switch>
                <AuthRoute exact path="/" component={Login} />
                <PrivateRoute exact path="/home" component={Home} />
                <PrivateRoute
                  exact
                  path="/caesar-vision/:alias"
                  component={BranchOffices}
                />
                <PrivateRoute
                  exact
                  path="/onboardings"
                  component={Onboardings}
                />
                <PrivateRoute exact path="/cron-jobs" component={CronJobs} />
                <PrivateRoute exact path="/update-csd" component={UpdateCsd} />
                <PrivateRoute
                  exact
                  path="/cancel-invoice"
                  component={CancelInvoice}
                />
                {/*<PrivateRoute exact path="/spdm/search-invoice" component={SearchInvoice}/>*/}
                <Route
                  component={() => <NotFound setShowNavbar={setShowNavbar} />}
                />
              </Switch>
            </Suspense>
          </AuthProvider>
        </main>
      </HelmetProvider>
    </div>
  );
}

export default Admin;
